import React from 'react';
import { APP_NAME } from '../constants';
import { IconChat } from './ChatIcons';

export default function ChatLauncher({ onOpen }) {
  return (
    <button className="chatbox-icon-button" onClick={onOpen} aria-label={`Hap ${APP_NAME}`}>
      <span className="chatbox-icon-pulse" aria-hidden="true" />
      <span className="chatbox-icon-glow" aria-hidden="true" />
      <IconChat />
      <span className="chatbox-icon-label">Pyet asistentin</span>
    </button>
  );
}
